import React, { useState } from "react";
import { Card, Button, Modal } from "../components.jsx";
import { useStore } from "../store.jsx";

/* ============================================================
   Talention — Tarjeta «Método de valoración» (pantalla Factores)
   Un método por empresa. Cambiarlo vacía las valoraciones del
   método que se deja (CAMBIAR_METODO), así que se confirma si
   hay alguna.
   ============================================================ */

const OPCIONES_METODO = [
  {
    value: "talention",
    label: "Método Talention",
    desc: "Factores y pesos configurables, con escalas salariales propias.",
  },
  {
    value: "ministerio",
    label: "Modelo Ministerio",
    desc: "Réplica de la Herramienta SVPT oficial: catálogo fijo y 10 agrupaciones.",
  },
];

/* Puestos con alguna respuesta en el método activo: los que perderían su valoración. */
function puestosConRespuestas(state) {
  const respuestas = state.metodo === "ministerio" ? state.ministerio.respuestas : state.valuations;
  return state.positions.filter(p => Object.keys(respuestas[p.id] || {}).length > 0).length;
}

function MetodoValoracionCard() {
  const { state, dispatch } = useStore();
  const [pendiente, setPendiente] = useState(null);
  const afectados = puestosConRespuestas(state);
  const destino = OPCIONES_METODO.find(o => o.value === pendiente);

  const elegir = (metodo) => {
    if (metodo === state.metodo) return;
    if (afectados === 0) dispatch({ type: "CAMBIAR_METODO", metodo });
    else setPendiente(metodo);
  };
  const confirmar = () => {
    dispatch({ type: "CAMBIAR_METODO", metodo: pendiente });
    setPendiente(null);
  };

  return (
    <Card eyebrow="Empresa" title="Método de valoración">
      <div className="grid grid-2">
        {OPCIONES_METODO.map(o => {
          const activo = state.metodo === o.value;
          return (
            <button
              key={o.value}
              type="button"
              aria-pressed={activo}
              onClick={() => elegir(o.value)}
              className="surface-soft"
              style={{
                display: "flex", gap: 12, alignItems: "flex-start", textAlign: "left",
                padding: "12px 14px", borderRadius: 12, cursor: "pointer",
                border: `1px solid ${activo ? "var(--ink-900)" : "var(--border)"}`,
              }}
            >
              <span className={"radio " + (activo ? "on" : "")} />
              <span>
                <span className="semi" style={{ display: "block", fontSize: 14 }}>{o.label}</span>
                <span className="tiny muted">{o.desc}</span>
              </span>
            </button>
          );
        })}
      </div>

      <Modal
        open={pendiente !== null}
        onClose={() => setPendiente(null)}
        title="Cambiar de método de valoración"
        footer={
          <>
            <Button variant="ghost" onClick={() => setPendiente(null)}>Cancelar</Button>
            <Button variant="primary" onClick={confirmar}>Cambiar de método</Button>
          </>
        }
      >
        <p style={{ margin: 0 }}>
          Si cambias a {destino?.label}, {afectados === 1 ? "1 puesto pierde" : `${afectados} puestos pierden`} su valoración actual.
        </p>
        <p className="muted" style={{ margin: "8px 0 0" }}>Los puestos y el organigrama se conservan.</p>
      </Modal>
    </Card>
  );
}

export { MetodoValoracionCard };
